import { getStoreByStorage } from '../../helpers';

export const loansRequestMock = [
    {
        id: 538,
        id_store: 1,
        created_at: '2023-06-02T17:05:24.000Z',
        updated_at: null,
        loan_request: {
            id: 620,
            id_external: '164579',
            id_loan_offer: 2104,
            id_loan: 2,
            id_loan_request_status: 1,
            id_user: null,
            id_account: null,
            metadata: {
                id_store: '1',
                response: {
                    amount: 5444,
                    idRequest: 164579,
                    additional: 66.12,
                    branchOffice: 'VICTOR HOGAR ELECTROSUR ALBERTI',
                    installments: 6,
                    NumeroCredito: 159274,
                    ivaPercentage: 21,
                    branchDomicile: 'Calle  Nro:  11 DE SEPTIEMBRE / Tel: ',
                    expirationDate: '2023-07-05T00:00:00',
                    interestAmount: 4348.3,
                    idPendingRequest: 1310230,
                    installmentAmount: 1643
                },
                // observation: '',
                // detailRequirement: 'FACTURA:B. ILEGIBLE/FALTANTE;',
                id_external_person: '1145297'
            },
            created_at: '2023-06-02T17:05:15.000Z',
            updated_at: null,
            amount: 5444,
            installments: 6,
            id_store: 1,
            external_person: {
                id: 543,
                id_external: '1145297',
                content: {
                    id: '1145297',
                    cuil: '20224046376',
                    email: 'norber@hotmai.com',
                    gender: 'm',
                    activity: {
                        id: 1,
                        description: null
                    },
                    bornDate: '23/05/1990',
                    document: 22404637,
                    lastName: 'LICIAGA',
                    domicilio: {
                        id: 1690925,
                        floor: '',
                        number: '1968',
                        street: 'Jorge Miles',
                        locality: null,
                        postcode: '1838',
                        province: null,
                        apartment: '',
                        idLocality: 5052,
                        idProvince: 2,
                        cellPhoneNumber: '0100',
                        cellPhoneAreaCode: '11',
                        additionalPhoneNumber: '2334',
                        additionalPhoneAreaCode: '3232',
                        cellPhoneCharacteristic: '2519',
                        additionalPhoneCharacteristic: '11'
                    },
                    firstName: 'NORBERTO EDUARDO',
                    reference: {
                        Id: 4521501,
                        Nombre: 'TEST,TEST',
                        Vinculo: 'test',
                        Telefono: '',
                        lastName: 'TEST',
                        Documento: 0,
                        firstName: 'TEST',
                        TipoDocumento: {
                            Id: 0,
                            Descripcion: null
                        },
                        TelefonoNumero: '1234',
                        TelefonoCelular: false,
                        TelefonoCodigoArea: '11',
                        TelefonoCaracteristica: '1234'
                    },
                    telephone: '1125190100',
                    monthlyAmount: 50000,
                    additionalTelephone: '3232112334'
                }
            }
        },
        sign_request: {
            id: 823,
            id_cuotitas_request_type: 3,
            id_cuotitas_request_status: 3,
            hash: 'xF8uVcgyCnLJtPM',
            metadata: {
                errors: [
                    {
                        code: 64052001,
                        attempt: 10,
                        message: 'Rekognition. No se superó la validación de gesto sonrisa (SS).',
                        created_at: '2023-06-02T22:24:44.879Z'
                    },
                    {
                        code: 500,
                        attempt: 9,
                        message: 'No valid selfie sent.',
                        created_at: '2023-06-02T22:23:37.664Z'
                    },
                    {
                        code: 64052002,
                        attempt: 8,
                        message: 'Rekognition. No se superó la validación de gesto ojos cerrados (SCE).',
                        created_at: '2023-06-02T20:04:44.532Z'
                    },
                    {
                        code: 64052001,
                        attempt: 7,
                        message: 'Rekognition. No se superó la validación de gesto sonrisa (SS).',
                        created_at: '2023-06-02T20:00:20.578Z'
                    },
                    {
                        code: 500,
                        attempt: 6,
                        message: 'No valid selfie sent.',
                        created_at: '2023-06-02T18:13:03.120Z'
                    },
                    {
                        code: 64052002,
                        attempt: 5,
                        message: 'Rekognition. No se superó la validación de gesto ojos cerrados (SCE).',
                        created_at: '2023-06-02T18:09:02.064Z'
                    },
                    {
                        code: 500,
                        attempt: 4,
                        message: 'No valid selfie sent.',
                        created_at: '2023-06-02T17:59:05.572Z'
                    },
                    {
                        code: 2001,
                        attempt: 3,
                        message: 'VU Face. No se detectó rostro en la selfie.',
                        created_at: '2023-06-02T17:12:15.291Z'
                    },
                    {
                        code: 64052001,
                        attempt: 2,
                        message: 'Rekognition. No se superó la validación de gesto sonrisa (SS).',
                        created_at: '2023-06-02T17:11:12.646Z'
                    },
                    {
                        code: 2001,
                        attempt: 1,
                        message: 'VU Face. No se detectó rostro en la selfie.',
                        created_at: '2023-06-02T17:09:45.502Z'
                    }
                ],
                idStore: '1',
                id_cuotitas_request: 823
            },
            created_at: '2023-06-02T17:05:24.000Z',
            updated_at: '2023-06-02T22:24:44.000Z',
            person: {
                id: 336954,
                id_person_type: 1,
                id_fiscal_iva_condition: 5,
                id_fiscal_iibb_condition: null,
                retentions: 0,
                active: 1,
                created_at: '2023-03-14T14:46:14.000Z',
                updated_at: null,
                id_person_origin: 3,
                attributes: [
                    {
                        id: 1325620,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'NORBERTO EDUARDO',
                        id_attribute: 64010002,
                        description: 'first_name'
                    },
                    {
                        id: 1325621,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'LICIAGA',
                        id_attribute: 64010003,
                        description: 'last_name'
                    },
                    {
                        id: 1325622,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'M',
                        id_attribute: 64010005,
                        description: 'gender'
                    }
                ],
                documents: [
                    {
                        id: 660471,
                        id_document_type: 1,
                        description: '22404637',
                        metadata: {
                            id_person: 336954
                        },
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null
                    }
                ],
                telephones: []
            }
        }
    },
    {
        id: 522,
        id_store: 1,
        created_at: '2023-05-17T12:53:34.000Z',
        updated_at: null,
        loan_request: {
            id: 603,
            id_external: '163337',
            id_loan_offer: 2071,
            id_loan: 2,
            id_loan_request_status: 1,
            id_user: null,
            id_account: null,
            metadata: {
                id_store: '1',
                response: {
                    amount: 7777,
                    idRequest: 163337,
                    additional: 94.46,
                    branchOffice: 'VICTOR HOGAR ELECTROSUR ALBERTI',
                    installments: 6,
                    NumeroCredito: 158032,
                    ivaPercentage: 21,
                    branchDomicile: 'Calle  Nro:  11 DE SEPTIEMBRE / Tel: ',
                    expirationDate: '2023-07-05T00:00:00',
                    interestAmount: 5128.679999999999,
                    idPendingRequest: 1281746,
                    installmentAmount: 2167
                },
                observation: 'Hola soy la sub fila 2',
                detailRequirement: 'FACTURA:B. ILEGIBLE/FALTANTE;',
                id_external_person: '1145297'
            },
            created_at: '2023-05-17T12:53:26.000Z',
            updated_at: null,
            amount: 7777,
            installments: 6,
            id_store: 1,
            external_person: {
                id: 543,
                id_external: '1145297',
                content: {
                    id: '1145297',
                    cuil: '20224046376',
                    email: 'norber@hotmai.com',
                    gender: 'm',
                    activity: {
                        id: 1,
                        description: null
                    },
                    bornDate: '23/05/1990',
                    document: 22404637,
                    lastName: 'LICIAGA',
                    domicilio: {
                        id: 1690925,
                        floor: '',
                        number: '1968',
                        street: 'Jorge Miles',
                        locality: null,
                        postcode: '1838',
                        province: null,
                        apartment: '',
                        idLocality: 5052,
                        idProvince: 2,
                        cellPhoneNumber: '0100',
                        cellPhoneAreaCode: '11',
                        additionalPhoneNumber: '2334',
                        additionalPhoneAreaCode: '3232',
                        cellPhoneCharacteristic: '2519',
                        additionalPhoneCharacteristic: '11'
                    },
                    firstName: 'NORBERTO EDUARDO',
                    reference: {
                        Id: 4521501,
                        Nombre: 'TEST,TEST',
                        Vinculo: 'test',
                        Telefono: '',
                        lastName: 'TEST',
                        Documento: 0,
                        firstName: 'TEST',
                        TipoDocumento: {
                            Id: 0,
                            Descripcion: null
                        },
                        TelefonoNumero: '1234',
                        TelefonoCelular: false,
                        TelefonoCodigoArea: '11',
                        TelefonoCaracteristica: '1234'
                    },
                    telephone: '1125190100',
                    monthlyAmount: 50000,
                    additionalTelephone: '3232112334'
                }
            }
        },
        sign_request: {
            id: 805,
            id_cuotitas_request_type: 3,
            id_cuotitas_request_status: 2,
            hash: '2OpUPHquckyA8bk',
            metadata: {
                idStore: '1'
            },
            created_at: '2023-05-17T12:53:34.000Z',
            updated_at: '2023-05-17T13:08:15.000Z',
            person: {
                id: 336954,
                id_person_type: 1,
                id_fiscal_iva_condition: 5,
                id_fiscal_iibb_condition: null,
                retentions: 0,
                active: 1,
                created_at: '2023-03-14T14:46:14.000Z',
                updated_at: null,
                id_person_origin: 3,
                attributes: [
                    {
                        id: 1325620,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'NORBERTO EDUARDO',
                        id_attribute: 64010002,
                        description: 'first_name'
                    },
                    {
                        id: 1325621,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'LICIAGA',
                        id_attribute: 64010003,
                        description: 'last_name'
                    },
                    {
                        id: 1325622,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'M',
                        id_attribute: 64010005,
                        description: 'gender'
                    }
                ],
                documents: [
                    {
                        id: 660471,
                        id_document_type: 1,
                        description: '22404637',
                        metadata: {
                            id_person: 336954
                        },
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null
                    }
                ],
                telephones: []
            }
        }
    },
    {
        id: 521,
        id_store: 1,
        created_at: '2023-05-17T12:15:58.000Z',
        updated_at: null,
        loan_request: {
            id: 602,
            id_external: '163336',
            id_loan_offer: 2070,
            id_loan: 2,
            id_loan_request_status: 1,
            id_user: null,
            id_account: null,
            metadata: {
                id_store: '1',
                response: {
                    amount: 6666,
                    idRequest: 163336,
                    additional: 80.96,
                    branchOffice: 'VICTOR HOGAR ELECTROSUR ALBERTI',
                    installments: 6,
                    NumeroCredito: 158031,
                    ivaPercentage: 21,
                    branchDomicile: 'Calle  Nro:  11 DE SEPTIEMBRE / Tel: ',
                    expirationDate: '2023-07-05T00:00:00',
                    interestAmount: 4396.000000000001,
                    idPendingRequest: 1281744,
                    installmentAmount: 1857
                },
                observation: 'Hola soy la sub fila 3',
                detailRequirement: 'FACTURA:B. ILEGIBLE/FALTANTE;',
                id_external_person: '1145297'
            },
            created_at: '2023-05-17T12:15:51.000Z',
            updated_at: null,
            amount: 6666,
            installments: 6,
            id_store: 1,
            external_person: {
                id: 543,
                id_external: '1145297',
                content: {
                    id: '1145297',
                    cuil: '20224046376',
                    email: 'norber@hotmai.com',
                    gender: 'm',
                    activity: {
                        id: 1,
                        description: null
                    },
                    bornDate: '23/05/1990',
                    document: 22404637,
                    lastName: 'LICIAGA',
                    domicilio: {
                        id: 1690925,
                        floor: '',
                        number: '1968',
                        street: 'Jorge Miles',
                        locality: null,
                        postcode: '1838',
                        province: null,
                        apartment: '',
                        idLocality: 5052,
                        idProvince: 2,
                        cellPhoneNumber: '0100',
                        cellPhoneAreaCode: '11',
                        additionalPhoneNumber: '2334',
                        additionalPhoneAreaCode: '3232',
                        cellPhoneCharacteristic: '2519',
                        additionalPhoneCharacteristic: '11'
                    },
                    firstName: 'NORBERTO EDUARDO',
                    reference: {
                        Id: 4521501,
                        Nombre: 'TEST,TEST',
                        Vinculo: 'test',
                        Telefono: '',
                        lastName: 'TEST',
                        Documento: 0,
                        firstName: 'TEST',
                        TipoDocumento: {
                            Id: 0,
                            Descripcion: null
                        },
                        TelefonoNumero: '1234',
                        TelefonoCelular: false,
                        TelefonoCodigoArea: '11',
                        TelefonoCaracteristica: '1234'
                    },
                    telephone: '1125190100',
                    monthlyAmount: 50000,
                    additionalTelephone: '3232112334'
                }
            }
        },
        sign_request: {
            id: 804,
            id_cuotitas_request_type: 3,
            id_cuotitas_request_status: 2,
            hash: 'UKYzmwjyvuu0yq4',
            metadata: {
                idStore: '1'
            },
            created_at: '2023-05-17T12:15:58.000Z',
            updated_at: '2023-05-17T14:12:03.000Z',
            person: {
                id: 336954,
                id_person_type: 1,
                id_fiscal_iva_condition: 5,
                id_fiscal_iibb_condition: null,
                retentions: 0,
                active: 1,
                created_at: '2023-03-14T14:46:14.000Z',
                updated_at: null,
                id_person_origin: 3,
                attributes: [
                    {
                        id: 1325620,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'NORBERTO EDUARDO',
                        id_attribute: 64010002,
                        description: 'first_name'
                    },
                    {
                        id: 1325621,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'LICIAGA',
                        id_attribute: 64010003,
                        description: 'last_name'
                    },
                    {
                        id: 1325622,
                        active: 1,
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null,
                        value: 'M',
                        id_attribute: 64010005,
                        description: 'gender'
                    }
                ],
                documents: [
                    {
                        id: 660471,
                        id_document_type: 1,
                        description: '22404637',
                        metadata: {
                            id_person: 336954
                        },
                        created_at: '2023-03-14T14:46:14.000Z',
                        updated_at: null
                    }
                ],
                telephones: []
            }
        }
    }
];

export const billRequestMock = [
    {
        id: 620,
        id_external: '164579',
        id_loan_offer: 2104,
        id_loan: 2,
        id_loan_request_status: 1,
        id_user: null,
        id_account: null,
        metadata: {
            id_store: '1',
            response: {
                amount: 5444,
                idRequest: 164579,
                additional: 66.12,
                branchOffice: 'VICTOR HOGAR ELECTROSUR ALBERTI',
                installments: 6,
                NumeroCredito: 159274,
                ivaPercentage: 21,
                branchDomicile: 'Calle  Nro:  11 DE SEPTIEMBRE / Tel: ',
                expirationDate: '2023-07-05T00:00:00',
                interestAmount: 4348.3,
                idPendingRequest: 1310230,
                installmentAmount: 1643
            },
            id_external_person: '1145297'
        },
        created_at: '2023-06-02T17:05:15.000Z',
        updated_at: null,
        amount: 5444,
        installments: 6,
        id_store: 1,
        id_loan_request_external_person: 543,
        request_files: []
    },
    {
        id: 603,
        id_external: '163337',
        id_loan_offer: 2071,
        id_loan: 2,
        id_loan_request_status: 1,
        id_user: null,
        id_account: null,
        metadata: {
            id_store: '1',
            response: {
                amount: 7777,
                idRequest: 163337,
                additional: 94.46,
                branchOffice: 'VICTOR HOGAR ELECTROSUR ALBERTI',
                installments: 6,
                NumeroCredito: 158032,
                ivaPercentage: 21,
                branchDomicile: 'Calle  Nro:  11 DE SEPTIEMBRE / Tel: ',
                expirationDate: '2023-07-05T00:00:00',
                interestAmount: 5128.679999999999,
                idPendingRequest: 1281746,
                installmentAmount: 2167
            },
            id_external_person: '1145297'
        },
        created_at: '2023-05-17T12:53:26.000Z',
        updated_at: null,
        amount: 7777,
        installments: 6,
        id_store: 1,
        id_loan_request_external_person: 543,
        request_files: []
    },
    {
        id: 602,
        id_external: '163336',
        id_loan_offer: 2070,
        id_loan: 2,
        id_loan_request_status: 1,
        id_user: null,
        id_account: null,
        metadata: {
            id_store: '1',
            response: {
                amount: 6666,
                idRequest: 163336,
                additional: 80.96,
                branchOffice: 'VICTOR HOGAR ELECTROSUR ALBERTI',
                installments: 6,
                NumeroCredito: 158031,
                ivaPercentage: 21,
                branchDomicile: 'Calle  Nro:  11 DE SEPTIEMBRE / Tel: ',
                expirationDate: '2023-07-05T00:00:00',
                interestAmount: 4396.000000000001,
                idPendingRequest: 1281744,
                installmentAmount: 1857
            },
            id_external_person: '1145297'
        },
        created_at: '2023-05-17T12:15:51.000Z',
        updated_at: null,
        amount: 6666,
        installments: 6,
        id_store: 1,
        id_loan_request_external_person: 543,
        request_files: [
            {
                id: 266,
                id_loan_request: 602,
                created_at: '2023-05-19T15:42:11.000Z',
                updated_at: null,
                file: {
                    id: 14177,
                    id_file_type: 2,
                    id_file_channel: 1,
                    description: 'https://staticfintech01-testing.s3.amazonaws.com/cuotitas/storeseller/files/602-TestFile.pdf',
                    metadata: {
                        bucket: 'staticfintech01-testing',
                        dirname: 'cuotitas/storeseller/files',
                        filename: '602-TestFile.pdf',
                        extention: '.pdf'
                    },
                    created_at: '2023-05-19T15:42:11.000Z',
                    updated_at: null
                }
            }
        ]
    }
];

// MOCKS de flujo de préstamo

// 0 https://api-stag.dinclin.com/cuotitasstores/stores/activities
export const activitiesMock = [
    {
        id: 2,
        description: 'EMPLEADO PRIVADO'
    },
    {
        id: 1,
        description: 'MONOTRIBUTISTA'
    },
    {
        id: 4,
        description: 'JUBILADO/PENSIONADO'
    },
    {
        id: 10,
        description: 'EMPLEADO PUBLICO NACIONAL O CIUDAD DE BS AS'
    },
    {
        id: 12,
        description: 'EMPLEADO PUBLICO PROVINCIAL O MUNICIPAL'
    },
    {
        id: 5,
        description: 'SERVICIO DOMESTICO'
    },
    {
        id: 6,
        description: 'JUBILADO CAJA 40'
    },
    {
        id: 7,
        description: 'PERSONAL UNIFORMADO'
    },
    {
        id: 8,
        description: 'CONTRATADO PRIVADO'
    },
    {
        id: 13,
        description: 'AUH'
    },
    {
        id: 3,
        description: 'AUTONOMO'
    },
    {
        id: 14,
        description: 'CUENTA PROPISTA'
    },
    {
        id: 15,
        description: 'AMA DE CASA'
    },
    {
        id: 16,
        description: 'ESTUDIANTE'
    }
];
// 1 https://api-stag.dinclin.com/cuotitasstores/people?firstName=&lastName=&document=26955439&gender=m&telephone=&async=f9d86e1c-e091-473e-be7a-2b86f7154232
export const putPeopleMock = {
    message: 'Task with id: 32081d4f-8d74-41cc-beba-e8a8625cfe11',
    task: {
        id: '32081d4f-8d74-41cc-beba-e8a8625cfe11',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            loanPerson: {
                id: '1147902',
                firstName: 'OSCAR ALFREDO',
                lastName: 'AVILA',
                document: 26955439,
                cuil: '20269554399',
                gender: 'm',
                email: '',
                bornDate: '01/03/1986',
                monthlyAmount: 414890,
                telephone: '3816152104',
                additionalTelephone: '',
                domicilio: {
                    id: 1693544,
                    street: 'falsa',
                    number: '123',
                    floor: '',
                    apartment: '',
                    idLocality: 24113,
                    locality: null,
                    idProvince: 9,
                    province: null,
                    postcode: '3636',
                    cellPhoneAreaCode: '381',
                    cellPhoneCharacteristic: '615',
                    cellPhoneNumber: '2104',
                    additionalPhoneAreaCode: '',
                    additionalPhoneCharacteristic: '',
                    additionalPhoneNumber: ''
                },
                reference: {
                    Id: 4830511,
                    Nombre: 'MESSI,LEO',
                    Vinculo: 'Vecino',
                    TelefonoCelular: false,
                    TelefonoCodigoArea: '11',
                    TelefonoCaracteristica: '1111',
                    TelefonoNumero: '1111',
                    Telefono: '',
                    Documento: 0,
                    TipoDocumento: {
                        Id: 0,
                        Descripcion: null
                    },
                    firstName: 'LEO',
                    lastName: 'MESSI'
                },
                activity: {
                    id: 1,
                    description: null
                }
            }
        }
    }
};
export const personByDocumentMock1 = [
    {
        apellido: 'PEREZ',
        nombre: 'JUAN',
        documento: '99999999',
        sexo: 'M',
        fechaNacimiento: '26/06/1999'
    }
];
export const personByDocumentMock2 = [
    {
        apellido: 'PEREZ',
        nombre: 'JUAN',
        documento: '99999999',
        sexo: 'M',
        fechaNacimiento: '26/06/1999'
    },
    {
        apellido: 'MARIA',
        nombre: 'GOMEZ',
        documento: '99999999',
        sexo: 'F',
        fechaNacimiento: '26/06/1989'
    },
    {
        apellido: 'CARLOS',
        nombre: 'FERNANDEZ',
        documento: '99999999',
        sexo: 'M',
        fechaNacimiento: '26/06/1997'
    }
];

// 2 https://api-stag.dinclin.com/cuotitasstores/people?async=d0d9b95b-df6b-4679-9af4-d9b07b6019e2
// export const postPeopleMock = {
//     error: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia: 854334',
//     code: 400,
//     extra: {
//         service: 'EXT01',
//         from: 'Cuotitas',
//         path: '/api/ecommerce/ModificarPersona',
//         method: 'POST',
//         result: {
//             Resultado: 2,
//             Mensaje: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia: 854334',
//             CodigoError: 0
//         },
//         logged: true,
//         trace: '{"store":"Club Atlético Newell\'s Old Boys","idStore":4,"username":"Sebas","idUser":10229,"client":"{\\"UniqueTraceId\\":\\"i34FIZ\\",\\"document\\":\\"34389941\\"}"}, QXJ5ye;8H;X8'
//     },
//     name: 'BadRequest'
// };
// 3 https://api-stag.dinclin.com/cuotitasstores/stores/policies
export const getPolicesMock = [
    {
        id: 573,
        code: '380',
        description: 'CELULARES BC',
        creditTypes: [
            {
                id: 2,
                description: 'PLAN DNI'
            }
        ],
        articles: [
            {
                id: 574,
                code: '40',
                description: 'CELULARES BC'
            }
        ],
        commercialPolicyDetails: [
            {
                id: 106504,
                code: 'PRODUCTOPAGOVOLUNTARIO',
                description: 'PRODUCTO PAGO VOLUNTARIO'
            },
            {
                id: 106509,
                code: 'VALIDARLISTANEGRA',
                description: 'VALIDAR LISTA NEGRA'
            },
            {
                id: 106537,
                code: 'VERIFICACIONTELEFONICATRADICIONAL',
                description: 'CIRCUITO DE VERIFICACION TELEFONICA TRADICIONAL'
            },
            {
                Valor: '84',
                id: 106539,
                code: 'VALIDAREDADMAXIMA',
                description: 'EDAD MAXIMA PERMITIDA'
            },
            {
                Valor: '18',
                id: 106540,
                code: 'VALIDAREDADMINIMA',
                description: 'EDAD MINIMA PERMITIDA'
            },
            {
                id: 106587,
                code: 'AGREGACOMPROMISOSINTERNOSCAPITALAPROBADO',
                description: 'AGREGAR COMPROMISOS INTERNOS A CAPITAL APROBADO'
            },
            {
                id: 106588,
                code: 'AGREGARIMAGENSOLICITUD',
                description: 'PERMITIR AGREGAR DOCUMENTACION AL FINALIZAR LA OPERACION'
            },
            {
                id: 106591,
                code: 'BASESPUCAFIP',
                description: 'Validar CUIT Base PUCAFIP'
            },
            {
                id: 106628,
                code: 'EJECUTARCONSULTAMOTORBANCOCOLUMBIA',
                description: 'EJECUTAR CONSULTA'
            },
            {
                id: 108181,
                code: 'NOSISTOMARFECHANACIMIENTO',
                description: 'TOMAR FECHA DE NACIMIENTO DESDE NOSIS'
            },
            {
                id: 110171,
                code: 'FORMAPAGODEPOSITOCUENTACOMERCIO',
                description: 'FORMA DE PAGO DEP. EN CUENTA COMERCIO'
            },
            {
                id: 111451,
                code: 'VALIDARVENTACARTERAPARACOMPROMISOSINTERNOS',
                description: 'VALIDAR VENTA CARTERA PARA COMPROMISOS INTERNOS'
            },
            {
                id: 112092,
                code: 'CALCULARRCICOMPROMISOSINTERNOS',
                description: 'CALCULAR RCI PARA COMPROMISOS INTERNOS'
            }
        ]
    },
    {
        id: 565,
        code: '363',
        description: 'COMPRAS BC',
        creditTypes: [
            {
                id: 2,
                description: 'PLAN DNI'
            }
        ],
        articles: [
            {
                id: 566,
                code: '20',
                description: 'COMPRAS BC'
            }
        ],
        commercialPolicyDetails: [
            {
                id: 104535,
                code: 'PRODUCTOPAGOVOLUNTARIO',
                description: 'PRODUCTO PAGO VOLUNTARIO'
            },
            {
                id: 104540,
                code: 'VALIDARLISTANEGRA',
                description: 'VALIDAR LISTA NEGRA'
            },
            {
                id: 104568,
                code: 'VERIFICACIONTELEFONICATRADICIONAL',
                description: 'CIRCUITO DE VERIFICACION TELEFONICA TRADICIONAL'
            },
            {
                id: 104618,
                code: 'AGREGARIMAGENSOLICITUD',
                description: 'PERMITIR AGREGAR DOCUMENTACION AL FINALIZAR LA OPERACION'
            },
            {
                id: 104621,
                code: 'BASESPUCAFIP',
                description: 'Validar CUIT Base PUCAFIP'
            },
            {
                id: 104730,
                code: 'EJECUTARCONSULTAMOTORBANCOCOLUMBIA',
                description: 'EJECUTAR CONSULTA'
            },
            {
                id: 106276,
                code: 'AGREGACOMPROMISOSINTERNOSCAPITALAPROBADO',
                description: 'AGREGAR COMPROMISOS INTERNOS A CAPITAL APROBADO'
            },
            {
                id: 108174,
                code: 'NOSISTOMARFECHANACIMIENTO',
                description: 'TOMAR FECHA DE NACIMIENTO DESDE NOSIS'
            },
            {
                id: 110163,
                code: 'FORMAPAGODEPOSITOCUENTACOMERCIO',
                description: 'FORMA DE PAGO DEP. EN CUENTA COMERCIO'
            },
            {
                id: 111443,
                code: 'VALIDARVENTACARTERAPARACOMPROMISOSINTERNOS',
                description: 'VALIDAR VENTA CARTERA PARA COMPROMISOS INTERNOS'
            },
            {
                id: 112085,
                code: 'CALCULARRCICOMPROMISOSINTERNOS',
                description: 'CALCULAR RCI PARA COMPROMISOS INTERNOS'
            }
        ]
    }
];

// 4 https://api-stag.dinclin.com/cuotitasstores/stores/4/offers?async=26513c21-c898-4a8c-a901-fa99ae623036
export const postOffersMock = {
    message: 'Task with id: b81f0bd7-4ae9-417b-b800-eb23bfc3e0ce',
    task: {
        id: 'b81f0bd7-4ae9-417b-b800-eb23bfc3e0ce',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            id: 2196,
            id_loan: 2,
            active: 1,
            id_user: null,
            max_amount: 693918.69,
            min_amount: 0,
            max_installments: 30,
            min_installments: 0,
            id_external: '1362409',
            metadata: {
                pricing: [
                    5,
                    'PLATINUM'
                ],
                id_store: '26',
                policies: {
                    id_external_article: '566',
                    id_external_credit_type: '2',
                    id_external_pricing_type: 5,
                    id_external_commerce_policy: '565'
                },
                id_external_person: '1147902',
                max_installment_amount: 275779.91,
                id_external_pending_offer: '1362409'
            },
            expires_at: null,
            created_at: '2023-07-14T16:43:22.000Z',
            updated_at: null
        }
    }
};
// 5 https://api-stag.dinclin.com/cuotitasstores/stores/4/offers/1201/installments
export const getInstallmentsMock = {
    id: 2196,
    active: 1,
    id_user: null,
    max_amount: 693918.69,
    min_amount: 0,
    max_installments: 30,
    min_installments: 0,
    id_external: '1362409',
    metadata: {
        pricing: [
            5,
            'PLATINUM'
        ],
        id_store: '26',
        policies: {
            id_external_article: '566',
            id_external_credit_type: '2',
            id_external_pricing_type: 5,
            id_external_commerce_policy: '565'
        },
        id_external_person: '1147902',
        max_installment_amount: 275779.91,
        id_external_pending_offer: '1362409'
    },
    expires_at: null,
    created_at: '2023-07-14T16:43:22.000Z',
    updated_at: null,
    loan: {
        id: 2,
        id_product: 2001,
        id_loan_provider: 1,
        priority: 1,
        metadata: {
            description: 'store-seller'
        },
        active: 1
    },
    installmentsInfo: {
        amountMin: 5000,
        amountMax: 700000,
        minInstallmentQuantity: 9,
        maxInstallmentQuantity: 30,
        ivaPercentage: 21
    },
    installments: [
        {
            TNA: 163,
            TEM: 13.58,
            TEA: 361.08,
            CFT: 163,
            CFTNA: 163,
            CFTTEA: 361.08,
            installments: 9,
            interestPercentage: 98.3478,
            firstExpirationDate: '2023-08-15T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 2.00757,
            interestCoefficient: 0.99542,
            expenseCoefficient: 0,
            sealingCoefficient: 0.01215,
            ivaCoefficient: 0.21159,
            installmentCoefficient: 0.22306,
            rawInstallmentCoefficient: 0.22306
        },
        {
            TNA: 163,
            TEM: 13.58,
            TEA: 361.08,
            CFT: 163,
            CFTNA: 163,
            CFTTEA: 361.08,
            installments: 12,
            interestPercentage: 135.0916,
            firstExpirationDate: '2023-08-15T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 2.37947,
            interestCoefficient: 1.36732,
            expenseCoefficient: 0,
            sealingCoefficient: 0.01215,
            ivaCoefficient: 0.28969,
            installmentCoefficient: 0.19829,
            rawInstallmentCoefficient: 0.19829
        },
        {
            TNA: 166,
            TEM: 13.83,
            TEA: 373.41,
            CFT: 166,
            CFTNA: 166,
            CFTTEA: 373.41,
            installments: 15,
            interestPercentage: 178.3937,
            firstExpirationDate: '2023-08-15T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 2.81775,
            interestCoefficient: 1.8056,
            expenseCoefficient: 0,
            sealingCoefficient: 0.01215,
            ivaCoefficient: 0.38173,
            installmentCoefficient: 0.18785,
            rawInstallmentCoefficient: 0.18785
        },
        {
            TNA: 168,
            TEM: 14,
            TEA: 381.79,
            CFT: 168,
            CFTNA: 168,
            CFTTEA: 381.79,
            installments: 18,
            interestPercentage: 224.3125,
            firstExpirationDate: '2023-08-15T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 3.28252,
            interestCoefficient: 2.27037,
            expenseCoefficient: 0,
            sealingCoefficient: 0.01215,
            ivaCoefficient: 0.47933,
            installmentCoefficient: 0.18236,
            rawInstallmentCoefficient: 0.18236
        },
        {
            TNA: 183,
            TEM: 15.25,
            TEA: 449.15,
            CFT: 183,
            CFTNA: 183,
            CFTTEA: 449.15,
            installments: 24,
            interestPercentage: 350.6003,
            firstExpirationDate: '2023-08-15T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 4.56073,
            interestCoefficient: 3.54859,
            expenseCoefficient: 0,
            sealingCoefficient: 0.01215,
            ivaCoefficient: 0.74775,
            installmentCoefficient: 0.19003,
            rawInstallmentCoefficient: 0.19003
        },
        {
            TNA: 183.5,
            TEM: 15.29,
            TEA: 451.54,
            CFT: 183.5,
            CFTNA: 183.5,
            CFTTEA: 451.54,
            installments: 30,
            interestPercentage: 458.5171,
            firstExpirationDate: '2023-08-15T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 5.65301,
            interestCoefficient: 4.64086,
            expenseCoefficient: 0,
            sealingCoefficient: 0.01215,
            ivaCoefficient: 0.97713,
            installmentCoefficient: 0.18843,
            rawInstallmentCoefficient: 0.18843
        }
    ]
};
// 5.b https://api-stag.dinclin.com/cuotitasstores/stores/4/offers/1201/installments
export const responseDoubleInsallmentMock = {
    id: 109491,
    active: 1,
    id_user: null,
    max_amount: 113271.12,
    min_amount: 0,
    max_installments: 24,
    min_installments: 0,
    id_external: '1369880',
    metadata: {
        pricing: [
            3,
            'BRONCE'
        ],
        id_store: '13121',
        policies: {
            id_external_article: '566',
            id_external_credit_type: '2',
            id_external_pricing_type: 3,
            id_external_commerce_policy: '565'
        },
        id_external_person: '1508308',
        max_installment_amount: 23528,
        id_external_pending_offer: '1369880'
    },
    expires_at: null,
    created_at: '2023-07-04T22:15:59.000Z',
    updated_at: null,
    loan: {
        id: 2,
        id_product: null,
        id_loan_provider: 1,
        priority: 1,
        metadata: {
            description: 'store-seller'
        },
        active: 1
    },
    installmentsInfo: {
        amountMin: 5000,
        amountMax: 250000,
        minInstallmentQuantity: 6,
        maxInstallmentQuantity: 24,
        ivaPercentage: 21
    },
    installments: [
        {
            TNA: 199,
            TEM: 16.58,
            TEA: 530.43,
            CFT: 199,
            CFTNA: 199,
            CFTTEA: 530.43,
            installments: 6,
            interestPercentage: 80.7185,
            firstExpirationDate: '2023-09-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 1.82544,
            interestCoefficient: 0.81534,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.17334,
            installmentCoefficient: 0.30424,
            rawInstallmentCoefficient: 0.30424
        },
        {
            TNA: 186,
            TEM: 15.5,
            TEA: 463.62,
            CFT: 186,
            CFTNA: 186,
            CFTTEA: 463.62,
            installments: 6,
            interestPercentage: 74.8784,
            firstExpirationDate: '2023-08-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 1.76645,
            interestCoefficient: 0.75635,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.16095,
            installmentCoefficient: 0.29441,
            rawInstallmentCoefficient: 0.29441
        },
        {
            TNA: 199,
            TEM: 16.58,
            TEA: 530.43,
            CFT: 199,
            CFTNA: 199,
            CFTTEA: 530.43,
            installments: 9,
            interestPercentage: 123.7418,
            firstExpirationDate: '2023-09-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 2.26002,
            interestCoefficient: 1.24992,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.2646,
            installmentCoefficient: 0.25111,
            rawInstallmentCoefficient: 0.25111
        },
        {
            TNA: 186,
            TEM: 15.5,
            TEA: 463.62,
            CFT: 186,
            CFTNA: 186,
            CFTTEA: 463.62,
            installments: 9,
            interestPercentage: 114.4462,
            firstExpirationDate: '2023-08-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 2.16612,
            interestCoefficient: 1.15602,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.24489,
            installmentCoefficient: 0.24068,
            rawInstallmentCoefficient: 0.24068
        },
        {
            TNA: 199,
            TEM: 16.58,
            TEA: 530.43,
            CFT: 199,
            CFTNA: 199,
            CFTTEA: 530.43,
            installments: 12,
            interestPercentage: 170.9834,
            firstExpirationDate: '2023-09-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 2.73721,
            interestCoefficient: 1.7271,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.36481,
            installmentCoefficient: 0.2281,
            rawInstallmentCoefficient: 0.2281
        },
        {
            TNA: 186,
            TEM: 15.5,
            TEA: 463.62,
            CFT: 186,
            CFTNA: 186,
            CFTTEA: 463.62,
            installments: 12,
            interestPercentage: 157.8332,
            firstExpirationDate: '2023-08-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 2.60438,
            interestCoefficient: 1.59428,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.33692,
            installmentCoefficient: 0.21703,
            rawInstallmentCoefficient: 0.21703
        },
        {
            TNA: 204,
            TEM: 17,
            TEA: 558.01,
            CFT: 204,
            CFTNA: 204,
            CFTTEA: 558.01,
            installments: 15,
            interestPercentage: 228.4029,
            firstExpirationDate: '2023-09-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 3.3172,
            interestCoefficient: 2.3071,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.48661,
            installmentCoefficient: 0.22115,
            rawInstallmentCoefficient: 0.22115
        },
        {
            TNA: 191,
            TEM: 15.92,
            TEA: 488.51,
            CFT: 191,
            CFTNA: 191,
            CFTTEA: 488.51,
            installments: 15,
            interestPercentage: 211.0412,
            firstExpirationDate: '2023-08-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 3.14183,
            interestCoefficient: 2.13173,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.44978,
            installmentCoefficient: 0.20946,
            rawInstallmentCoefficient: 0.20946
        },
        {
            TNA: 209,
            TEM: 17.42,
            TEA: 586.68,
            CFT: 209,
            CFTNA: 209,
            CFTTEA: 586.68,
            installments: 18,
            interestPercentage: 291.8731,
            firstExpirationDate: '2023-09-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 3.95831,
            interestCoefficient: 2.94821,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.62125,
            installmentCoefficient: 0.21991,
            rawInstallmentCoefficient: 0.21991
        },
        {
            TNA: 196,
            TEM: 16.33,
            TEA: 514.4,
            CFT: 196,
            CFTNA: 196,
            CFTTEA: 514.4,
            installments: 18,
            interestPercentage: 270.1464,
            firstExpirationDate: '2023-08-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 3.73885,
            interestCoefficient: 2.72875,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.57516,
            installmentCoefficient: 0.20771,
            rawInstallmentCoefficient: 0.20771
        },
        {
            TNA: 216,
            TEM: 18,
            TEA: 628.76,
            CFT: 216,
            CFTNA: 216,
            CFTTEA: 628.76,
            installments: 24,
            interestPercentage: 427.3796,
            firstExpirationDate: '2023-09-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 5.32707,
            interestCoefficient: 4.31696,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.90868,
            installmentCoefficient: 0.22196,
            rawInstallmentCoefficient: 0.22196
        },
        {
            TNA: 203,
            TEM: 16.92,
            TEA: 552.4,
            CFT: 203,
            CFTNA: 203,
            CFTTEA: 552.4,
            installments: 24,
            interestPercentage: 396.9529,
            firstExpirationDate: '2023-08-05T00:00:00',
            expense: 0,
            selected: true,
            totalCoefficient: 5.01973,
            interestCoefficient: 4.00962,
            expenseCoefficient: 0,
            sealingCoefficient: 0.0101,
            ivaCoefficient: 0.84414,
            installmentCoefficient: 0.20916,
            rawInstallmentCoefficient: 0.20916
        }
    ]
};
// 6 https://api-stag.dinclin.com/cuotitasstores/device/verify?async=d8cac2cb-ad19-4630-b47d-dec91f116128
export const postVerifyMock = {
    message: 'Task with id: d8cac2cb-ad19-4630-b47d-dec91f116128',
    task: {
        id: 'd8cac2cb-ad19-4630-b47d-dec91f116128',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            code: 200,
            message: 'Ok',
            notification: {
                id: 13324,
                id_notification_status: 2,
                sms_status: 'sent'
            }
        }
    }
};
// 7 https://api-stag.dinclin.com/cuotitasstores/device/validate
export const postValidateMock = {
    metadata: {
        idStore: getStoreByStorage()?.id || 26,
    },
    telephone: '+5491139368836',
    idExternal: '1147902',
    attemptsAvailable: 3
};
// 8 https://api-stag.dinclin.com/cuotitasstores/people?async=35d707db-ee4c-435d-ab7c-bb943f633228
export const postPeopleCompleteMock = {
    message: 'Task with id: b02e48bb-1429-4d71-ad39-40296231893a',
    task: {
        id: 'b02e48bb-1429-4d71-ad39-40296231893a',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            attributes: {
                first_name: {
                    value: 'OSCAR ALFREDO'
                },
                last_name: {
                    value: 'AVILA'
                },
                gender: {
                    value: 'm'
                },
                born_date: {
                    value: '1986-03-01T03:00:00.000Z'
                },
                address: {
                    value: {
                        idProvince: 9,
                        idLocality: 24113,
                        postcode: '3636',
                        street: 'falsa',
                        number: '123',
                        floor: '',
                        apartment: ''
                    }
                },
                reference: {
                    value: {
                        firstName: 'LEO',
                        lastName: 'MESSI',
                        relation: 'Vecino',
                        isCellPhone: false,
                        telephoneAreaCode: '11',
                        telephoneCharacteristic: '1111',
                        telephoneNumber: '1111'
                    }
                }
            },
            documents: [
                {
                    type: {
                        id: 1,
                        description: 'dni'
                    },
                    description: '26955439'
                }
            ],
            emails: [
                {
                    type: {
                        id: 1,
                        description: 'principal'
                    },
                    description: ''
                }
            ],
            cellphone: {
                cellPhoneAreaCode: '11',
                cellPhoneCharacteristic: '3936',
                cellPhoneNumber: '8836'
            },
            additionalPhone: {
                areaCode: '',
                characteristic: '',
                number: ''
            },
            telephones: [
                {
                    type: {
                        id: 1,
                        description: 'personal'
                    }
                }
            ],
            loanPerson: {
                id: '1147902',
                firstName: 'OSCAR ALFREDO',
                lastName: 'AVILA',
                document: 26955439,
                cuil: '20269554399',
                gender: 'm',
                email: '',
                bornDate: '01/03/1986',
                monthlyAmount: 414890,
                telephone: '1139368836',
                additionalTelephone: '',
                domicilio: {
                    id: 1693544,
                    street: 'falsa',
                    number: '123',
                    floor: '',
                    apartment: '',
                    idLocality: 24113,
                    locality: null,
                    idProvince: 9,
                    province: null,
                    postcode: '3636',
                    cellPhoneAreaCode: '11',
                    cellPhoneCharacteristic: '3936',
                    cellPhoneNumber: '8836',
                    additionalPhoneAreaCode: '',
                    additionalPhoneCharacteristic: '',
                    additionalPhoneNumber: ''
                },
                reference: {
                    Id: 4830511,
                    Nombre: 'MESSI,LEO',
                    Vinculo: 'Vecino',
                    TelefonoCelular: false,
                    TelefonoCodigoArea: '11',
                    TelefonoCaracteristica: '1111',
                    TelefonoNumero: '1111',
                    Telefono: '',
                    Documento: 0,
                    TipoDocumento: {
                        Id: 0,
                        Descripcion: null
                    },
                    firstName: 'LEO',
                    lastName: 'MESSI'
                },
                activity: {
                    id: 1,
                    description: null
                }
            }
        }
    }
};
// 9 https://api-test.dinclin.com/cuotitasstores/stores/26/requests?async=c254422b-b48e-437f-b4fb-eab5f1488b06
export const postRequestMock = {
    message: 'Task with id: c254422b-b48e-437f-b4fb-eab5f1488b06',
    task: {
        id: 'c254422b-b48e-437f-b4fb-eab5f1488b06',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            id: 904,
            id_cuotitas_request_type: 3,
            id_cuotitas_request_status: 1,
            id_person: 728481,
            hash: 'xUlPeUVObZhf1l8',
            metadata: {
                idStore: '26'
            },
            created_at: '2023-07-14T17:53:41.000Z',
            updated_at: null,
            request_files: [
                {
                    id: 4579,
                    id_cuotitas_request: 904,
                    id_file: 15939,
                    signed: 0,
                    active: 1,
                    informative: 0,
                    created_at: '2023-07-14T17:53:41.000Z',
                    updated_at: null
                },
                {
                    id: 4580,
                    id_cuotitas_request: 904,
                    id_file: 15940,
                    signed: 0,
                    active: 1,
                    informative: 0,
                    created_at: '2023-07-14T17:53:41.000Z',
                    updated_at: null
                },
                {
                    id: 4581,
                    id_cuotitas_request: 904,
                    id_file: 15941,
                    signed: 0,
                    active: 1,
                    informative: 0,
                    created_at: '2023-07-14T17:53:41.000Z',
                    updated_at: null
                },
                {
                    id: 4582,
                    id_cuotitas_request: 904,
                    id_file: 15942,
                    signed: 0,
                    active: 1,
                    informative: 1,
                    created_at: '2023-07-14T17:53:41.000Z',
                    updated_at: null
                }
            ],
            person: {
                id: 728481,
                id_person_type: 1,
                id_fiscal_iva_condition: 5,
                id_fiscal_iibb_condition: null,
                retentions: 0,
                active: 1,
                created_at: '2023-05-16T13:08:59.000Z',
                updated_at: null,
                id_person_origin: 3,
                attributes: [
                    {
                        id: 4935091,
                        active: 1,
                        created_at: '2023-05-16T13:08:59.000Z',
                        updated_at: null,
                        value: 'OSCAR ALFREDO',
                        id_attribute: 64010002,
                        description: 'first_name'
                    },
                    {
                        id: 4935092,
                        active: 1,
                        created_at: '2023-05-16T13:08:59.000Z',
                        updated_at: null,
                        value: 'AVILA',
                        id_attribute: 64010003,
                        description: 'last_name'
                    },
                    {
                        id: 4935093,
                        active: 1,
                        created_at: '2023-05-16T13:08:59.000Z',
                        updated_at: null,
                        value: 'M',
                        id_attribute: 64010005,
                        description: 'gender'
                    }
                ],
                documents: [
                    {
                        id: 1443481,
                        id_document_type: 1,
                        description: '26955439',
                        metadata: {
                            id_person: 728481
                        },
                        created_at: '2023-05-16T13:08:59.000Z',
                        updated_at: null
                    }
                ],
                telephones: []
            }
        }
    }
};
// 10 https://api-test.dinclin.com/cuotitasstores/notifications
export const postNotificationMock = {
    code: 200,
    message: 'Ok'
};

//
// ERROR MOCK
//

// 9 https://api-test.dinclin.com/cuotitasstores/stores/26/requests?async=c254422b-b48e-437f-b4fb-eab5f1488b06
export const postRequestErrorMock = {
    message: 'Task with id: ad67bedf-fc21-4104-af61-8a780d9a18f3',
    task: {
        id: 'ad67bedf-fc21-4104-af61-8a780d9a18f3',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            error: 'Provider returned invalid state',
            code: 500,
            extra: {
                trace: '{"store":"Club Atlético Newell\'s Old Boys","idStore":4,"username":"Sebas","idUser":10229,"client":"{}"}, 02g0Xj;nd;MH',
                from: 'loans',
                path: '/requests/stores/4',
                method: 'post'
            },
            name: 'InternalServerError'
        }
    }
};
